<template>
  <div class="navigation">
    <!--<div @click="openNav">
      <burger></burger>
    </div>-->

    <div class="links">
      <rp-permissions :requireAll="['read_reports']">
        <router-link :to="{name: 'Overview'}" :class="{active: isDashboard}">
          <div class="nav-wrapper">
            <rp-sprite name="dashboard"/>
            <div class="nav-label">Dashboard</div>
          </div>
        </router-link>
      </rp-permissions>

      <rp-permissions :requireAll="['write_patients', 'write_operations']">
        <router-link to="/patients/add-patients" :class="{active: isAddPatients}">
          <div class="nav-wrapper">
            <rp-sprite name="person_add"/>
            <div class="nav-label">Add Patients & Surgeries</div>
          </div>
        </router-link>
      </rp-permissions>

      <rp-permissions :requireAll="['write_patients', 'write_operations']">
        <router-link to="/patients/add-patient-preop" :class="{active: isAddPatientPreop}">
          <div class="nav-wrapper">
            <rp-sprite name="person_add"/>
            <div class="nav-label">Add Patient & Pre-Op</div>
          </div>
        </router-link>
      </rp-permissions>

      <rp-permissions :requireOne="['read_patients']">
        <router-link to="/patients" :class="{active: isUsers}">
          <div class="nav-wrapper">
            <rp-sprite name="people"/>
            <div class="nav-label">All Patients</div>
          </div>
        </router-link>
      </rp-permissions>

      <rp-permissions :requireAll="['read_users', 'write_users']">
        <router-link to="/users" :class="{active: isUsers}">
          <div class="nav-wrapper">
            <rp-sprite name="people"/>
            <div class="nav-label">All Users</div>
          </div>
        </router-link>
      </rp-permissions>

      <rp-permissions :requireOne="['read_distributor_users', 'read_hospital_users', 'read_moderator_users']">
        <router-link to="/users" :class="{active: isUsers}">
          <div class="nav-wrapper">
            <rp-sprite name="people"/>
            <div class="nav-label">Users</div>
          </div>
        </router-link>
      </rp-permissions>

      <rp-permissions :requireOne="['read_hospitals', 'write_hospitals']">
        <router-link to="/hospitals" active-class="active">
          <div class="nav-wrapper">
            <rp-sprite name="location_on"/>
            <div class="nav-label">Hospitals</div>
          </div>
        </router-link>
      </rp-permissions>
      
      <rp-permissions :requireOne="['read_messages', 'write_messages']">
        <router-link to="/messages" :class="{active: isMessages}">
          <!--<rp-sprite name="message"/>
          <div v-if="hasUnreadMessage" class="notification-circle"></div>-->
          <div class="nav-wrapper">
            <rp-sprite name="message"/>
            <div v-if="hasUnreadMessage" class="notification-circle"></div>
            <div class="nav-label">Messages</div>
          </div>
        </router-link>
      </rp-permissions>

      <rp-permissions v-if="isAdmin || isSurgeon" :requireOne="['read_trials']">
        <router-link :to="getClinicalRoute" active-class="active">
          <div class="nav-wrapper">
            <rp-sprite name="raypro_icon"/>
            <div class="nav-label">RayPRO Clinical</div>
          </div>
        </router-link>
      </rp-permissions>
    </div>

    <div class="links">
      <router-link :to="{name: 'PersonalInfo'}" :class="{active: isSettings}">
        <rp-sprite name="settings"/>
      </router-link>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import RpSprite from 'raypro_ui/src/components/ui/Sprite'
import Burger from '@/components/Burger'
import Permissions from 'raypro_ui/src/components/Permissions'
import PermissionMixin from 'raypro_ui/src/mixins/permission.js'

export default {
  components: {
    RpSprite,
    Burger,
    'rp-permissions': Permissions
  },

  mixins: [PermissionMixin],

  computed: {
    ...mapGetters(['hasUnreadMessage', 'isDistributor', 'isAdmin', 'isSurgeon', 'authUser']),

    path() {
      return this.$route.path
    },

    isUsers() {
      return new RegExp('/patients').test(this.path) ||
        new RegExp('/operations(?!/(nurse-)?upload-operations)').test(this.path) ||
        new RegExp('/surgeons').test(this.path) ||
        new RegExp('/nurses').test(this.path) ||
        new RegExp('/users').test(this.path) ||
        new RegExp('/raypro_admins').test(this.path) ||
        new RegExp('/hospital_admins').test(this.path) ||
        new RegExp('/rayner_distributor').test(this.path)
    },

    isMessages() {
      return new RegExp('/messages').test(this.path) ||
        new RegExp('/compose-message').test(this.path) ||
        new RegExp('/sent-messages').test(this.path)
    },

    isSettings() {
      return new RegExp('/settings').test(this.path)
    },

    isDashboard() {
      return new RegExp('/dashboard').test(this.path)
    },

    isAddPatients() {
      return new RegExp('/patients/add-patients').test(this.path)
    },

    isAddPatientPreop() {
      return new RegExp('/patients/add-patient-preop').test(this.path)
    },

    isMultipleUpload() {
      return new RegExp('/upload-operations').test(this.path) ||
        new RegExp('/nurse-upload-operations').test(this.path)
    },

    isClinical() {
      return new RegExp('/clinical').test(this.path)
    },

    getClinicalRoute() {
      return this.isAdmin 
        ? {name: 'all-studies'}
        : {name: 'view-surgeon-trials', params: {id: this.authUser.id}}
    }
  },

  methods: {
    ...mapActions(['checkUnreadMessage']),

    openNav() {
      this.$emit('openNav')
    }
  },

  mounted() {
    if(this.userHasPermission(['read_messages'])) {
      this.checkUnreadMessage()
    }
  }
}
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import '../stylesheets/helpers/mixins'
  @import '../stylesheets/helpers/extends'

  .navigation
    display: flex
    justify-content: space-between
    align-items: center
    height: 50px
    background-color: $color-primary
    overflow: hidden

    .links
      display: flex
      align-items: center
      color: $color-panel-bg

      .nav-wrapper
        display: flex
        align-items: center

        .nav-label
          font-size: 14px
          margin-right: 20px
          font-family: 'Stolzl'

      .page-patient-questionnaire &
        display: none

      a
        cursor: pointer
        fill: #fff
        transition: fill .5s ease-in-out
        position: relative

        &:after
          content: ''
          transition: opacity .5s ease-in-out
          //background: rgba(0, 0, 0, 0.6)
          position: absolute
          left: 0
          bottom: -11px
          width: 100%
          height: 2px
          opacity: 0

        &.active
          //fill: rgba(0, 0, 0, 0.6)

          &:after
            opacity: 1

        .sprite
          width: 25px
          height: 25px
          margin: 0 5px

          @include media($media-small)
            margin: 0 15px

          svg
            fill: $color-panel-bg

      .notification-circle
        width: 8px
        height: 8px
        border-radius: 50%
        background-color: red
        position: absolute
        top: -2px
        left: 12px

        @include media($media-small)
            //right: 12px
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue